import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { CoordinationService } from 'src/app/shared/services/API/billing/coordination.service';

@Component({
  selector: 'app-coordination-delete-modal',
  templateUrl: './coordination-delete-modal.component.html',
  styleUrls: ['./coordination-delete-modal.component.css']
})
export class CoordinationDeleteModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<CoordinationDeleteModalComponent>,
    private alertService: AlertService,
    private coordinationService: CoordinationService
  ) { }

  public isLoading:boolean;  

  ngOnInit(): void {
    this.isLoading = false;
  }
  
  close(){
    this.matDialogRef.close({deleteCoordination: false}); 
  }
  
  clickDelete(){
    
    this.isLoading = true;

    this.coordinationService.Delete(this.data.idCoordination).subscribe({
      next: (response)=>{      
        if(response.isError){
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }                
        this.alertService.show('Sucesso', "Coordenadoria excluída com sucesso!", AlertType.success); 
        this.matDialogRef.close({deleteCoordination: true}); 
    },
    error: (error)=>{
      console.log(error)
      this.isLoading = false;
      this.alertService.show('Erro inesperado', error, AlertType.error);
    }
  });
  }
  
  clickCancel(){
    this.matDialogRef.close({deleteCoordination: false}); 
  }
}